import thiefDoge from "assets/images/doge/thief.png";
import froggoDoge from "assets/images/doge/froggo.png";
import kingDoge from "assets/images/doge/king.png";
import japaneseDoge from "assets/images/doge/japanese.png";
import astronoutDoge from "assets/images/doge/astronout.png";
import robinDoge from "assets/images/doge/robin.png";

export const dogeImgList = [
  thiefDoge,
  froggoDoge,
  kingDoge,
  japaneseDoge,
  astronoutDoge,
  robinDoge,
];
